import { createApp } from 'vue'
import App from './components/App.vue'
import router from './router'

// 启动 Mock 模式：当环境变量开启，或处于指定的演示环境域名时
const mockDomains = ['vercel.app', 'preview.chichi.qzz.io', 'pre.chichix.xyz'];
const isMockDomain = mockDomains.some(domain => window.location.hostname.includes(domain));

if (process.env.VUE_APP_USE_MOCK === 'true' || isMockDomain) {
  import('./mock').then(m => m.initMock());
}

const app = createApp(App)
app.use(router)
app.mount('#app')
